import { setBearerToken, setUserData } from '@/common/axios/axios.instance';
import {
  ENDPOINT_LOGIN,
  ENDPOINT_SESSION,
  MODAL_KEYS,
  ROUTE_LOADS,
} from '@/common/constants';
import { HttpApi } from '@/common/http/HttpApi';
import { useModal } from '@/hooks/useModal';
import useStore from '@/lib/store';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { AuthSchema } from '../schema/auth.schema';

interface LoginCredentials {
  username: string;
  password: string;
}

const httpApi = new HttpApi();

export const useAuth = () => {
  const { fetchUser } = useStore();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { openModal } = useModal(MODAL_KEYS.CROP_SELECTION);
  const [sessionData, setSessionData] = useState<any>(null);

  const form = useForm<LoginCredentials>({
    defaultValues: {
      username: '',
      password: '',
    },
    resolver: yupResolver(AuthSchema),
  });

  const authLogin = ({ data, config }: any) => {
    return httpApi.post(ENDPOINT_LOGIN, data, config);
  };

  const onSubmit = async (data: LoginCredentials): Promise<void> => {
    setIsLoading(true);
    try {
      const token = await httpApi.post(ENDPOINT_SESSION, {});
      const response = await authLogin({
        data,
        config: { headers: { Authorization: `Bearer ${token?.id}` } },
      });
      setSessionData(token);
      fetchUser();
      if (response?.platform_type === null) {
        openModal();
      } else {
        setBearerToken(response?.session_id);
        setUserData(response?.session_id);
        navigate(ROUTE_LOADS);
        toast.success('Muvaffaqiyatli kirdingiz!');
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message || 'Login yoki parol noto‘g‘ri',
      );
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleErrors = (errors: any) => {
    console.log('Form validation errors:', errors);
  };

  const handleForm = form.handleSubmit(onSubmit, handleErrors);

  return {
    form,
    handleForm,
    isLoading,
    sessionData,
  };
};
